import { Position } from 'reactflow';
import Subdiagram from "../classes/Subdiagram";

export const subdiagram = [
  new Subdiagram({
      alias: "subdiagram-parent-to-child", 
      svgSrc: "/symbol-assets/AgregarSeccion.svg", 
      label: "Subdiagrama",
      handles: [
        {
          type: "target",
          position: Position.Top
        }      
      ]
  }),
  new Subdiagram({
      alias: "subdiagram-child-to-parent", 
      svgSrc: "/symbol-assets/AgregarSeccion.svg", 
      label: "Subdiagrama",
      handles: [
        {
          type: "source",
          position: Position.Bottom
        }      
      ]
  })
];
